import React, { useEffect, useRef, useState } from 'react';
import close from '../../assets/Images/close.svg';
import '../../assets/Css/modal.css';
import { Postdata } from '../../API/GlobalApi';
import Notifier from '../../../../Utils/notify';
import Session from '../../Utills/Session';


export const OtpInput = ({ isOpen, onClose, otptext, mobile, onVerified, setOtpText }) => {
    const [otp, setOtp] = useState(['', '', '', '']);
    const otpInputs = useRef([]);
    const [isOtpFilled, setIsOtpFilled] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [resendTimer, setResendTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    // Focus first input on open
    useEffect(() => {
        if (isOpen) {
            setOtp(['', '', '', '']);
            setTimeout(() => otpInputs.current[0]?.focus(), 50);
            startCountdown();
        }
    }, [isOpen]);

    const startCountdown = () => {
        setCanResend(false);
        setResendTimer(60);
        const countdown = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleOtpChange = (e, index) => {
        const value = e.target.value.replace(/\D/g, '');
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            otpInputs.current[index + 1]?.focus();
        } else if (!value && index > 0) {
            otpInputs.current[index - 1]?.focus();
        }

        setIsOtpFilled(newOtp.every(d => d.length === 1));
    };



    const handleSubmit = async () => {
        if (!isOtpFilled || submitting) return;
        setSubmitting(true);

        try {
            const response = await Postdata("contest-participants/verify-mobile/otp/", {
                otp: otp.join(''),
                mobile,
                user_type:"register"
            });

            console.log("response after submit", response);

            const participant = response?.participant;

            const userDetail = {
                id: participant?.id || '',
                name: participant?.name || '',
                fatherName: participant?.father_name || '',
                previousInstitution: participant?.previous_institution || '',
                intermediateMarks: participant?.intermediate_marks || '',
                aadhaarNo: participant?.aadhar || '',
                mobile: mobile,
                payment_completed: participant?.payment_completed,
            };

            // If already registered, show message but still pass data
            if (participant?.payment_completed === true) {
                Notifier.success("Your registration has already been completed.");
                onVerified?.(userDetail); // Still pass the data
                onClose(); // Close the modal
                return;
            }

            Notifier.success(response?.detail || "OTP verified successfully!");
            
            onVerified?.(userDetail);
            onClose();

        } catch (error) {
            console.log("error in OTP submit:", error);

            Notifier.error(
                typeof error === "string"
                    ? error
                    : error?.error || "OTP verification failed. Please try again."
            );
        } finally {
            setSubmitting(false);
        }
    };






    const handleResendOtp = async () => {
        if (!canResend) return;

        startCountdown();
        try {
            const response = await Postdata("contest-participants/verify-mobile/", { mobile });
            setOtpText(response?.otp);
            Notifier.success("OTP resent successfully!");
            setOtp(['', '', '', '']);
        } catch (error) {
            console.error("Error resending OTP:", error);
            Notifier.error(
                typeof error === "string"
                    ? error
                    : error?.error || error?.message || "Failed to resend OTP."
            );
        }
    };


    if (!isOpen) return null;

    return (
        <div className="modal-overlay verify-payment-modal arct-modal">
            <div className="modal-content" style={{ position: 'relative', width: '30%', padding: '25px' }}>
                {/* Header */}
                <div className="modal-header-content d-flex justify-content-between align-items-center mb-3">
                    <h2 className="verifytitle" style={{ color: '#DE0949', textAlign: 'center' }}>Verify OTP</h2>
                    <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Body */}
                <div className="modal-body">
                    {/* {otptext && (
                        <p style={{ fontWeight: 'bold', color: '#555', fontSize: '16px' }}>
                            OTP (test): <span style={{ color: '#7F56DA' }}>{otptext}</span>
                        </p>
                    )} */}

                    <div className="col-md-12">
                        <div className="row align-items-center">
                            {/* OTP Input Fields */}
                            <div className="col-md-12 d-flex gap-2 justify-content-center">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        value={digit}
                                        ref={el => otpInputs.current[index] = el}
                                        onChange={e => handleOtpChange(e, index)}
                                        onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                                        maxLength="1"
                                        className="otp-input"
                                        style={{
                                            width: '100%',
                                            maxWidth: '50px',
                                            textAlign: 'center',
                                            borderRadius: '6px',
                                            border: '1px solid #ccc',
                                            fontSize: '15px',
                                            height: '40px',
                                        }}
                                    />
                                ))}
                            </div>

                            {/* Timer & Action Buttons */}
                            <div className="col-md-12">
                                <div className="row d-flex resendrow align-items-center">
                                    {/* Left - Countdown */}
                                    <div className="col-md-7 d-flex align-items-center mt-2">
                                        {!canResend && (
                                            <p className="text-muted mt-2" style={{ fontSize: '14px' }}>
                                                Resend OTP available in <strong>{resendTimer}s</strong>
                                            </p>
                                        )}
                                    </div>

                                    {/* Right - Resend or Verify */}
                                    <div className="col-md-5 d-flex justify-content-end mt-4">
                                        {canResend ? (
                                            <button
                                                onClick={handleResendOtp}
                                                className="otpverify"
                                                style={{ fontWeight: 'bold', textDecoration: 'none' }}
                                            >
                                                Resend OTP
                                            </button>
                                        ) : (
                                            <button
                                                disabled={!isOtpFilled || submitting}
                                                onClick={handleSubmit}
                                                className="otpverify"
                                            >
                                                {submitting ? 'Verifying...' : 'Verify'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
